import React, { useState,useRef } from 'react'
import {ReactComponent as CloseIcon} from "../../../../design-system/design_system/assets/icons/components/notifications/close.svg";
import MobileMenuSlide from "./MobileMenuSlide";
import BookSubMenuMobile from "./BookSubMenuMobile";
import { connect } from 'react-redux';
import{setMobileMenuState, setMobileOverlayDisplay} from "../../../actions/HeaderActions";
import DreamSubMenuMobile from "./DreamSubMenuMobile";
import NotificationSlide from "../NotificationSlide";
import{bindActionCreators} from "redux";
const MobileSubMenu = (props) => {
    const{headerNav,setMobileMenuStateFunc,
        setMobileOverlayDisplayFunc, MainMenuLinkText,deviceWidth, mobileMenuState, customeProfileDetails}=props;
    //const [deviceWidth, setDeviceWidth] = useState(window.screen.width);
    //const imagePath = window.weeksWebCloudConfig.REACT_APP_IMAGEURL;
    let bookMenuArr, bookMenuSecondThemeArr, dreamMenuArr, secondaryNavArr = [];
    
    headerNav.map(data =>{
        if(Object.keys(data)[0] === "LinksWithTravel") {
            bookMenuArr = data.LinksWithTravel;
        }
        else if( Object.keys(data)[0] === "LinksWithoutTravel"){
            //debugger;
            bookMenuArr = data.LinksWithoutTravel;
        }
        else if(Object.keys(data)[0] === "LinksWithActivities") {
            dreamMenuArr = data.LinksWithActivities;
        }
        else if(Object.keys(data)[0] === "Links") {
            secondaryNavArr.push(data);
            //setbookSubmenuArr(data.LinksWithTravel);
            //console.log(bookSubmenuArr);
        }
    })
    
       
      const backMainMenu =()=>{
          //(mobileMenuState === "BOOK" || mobileMenuState === "DREAM") && setMobileMenuStateFunc("ALL");
      }
        const backMobileMenu =(mobileMenuState)=>{
            //debugger;
            setMobileMenuStateFunc("ALL");
            setMobileOverlayDisplayFunc(true);
            sessionStorage.setItem("NOTIFICATION_FLAG", true);    
        }

        return (
            <>
             
            <div className="col-12 border-bottom p-0">
                
              {/*   {
                    (mobileMenuState === "BOOK" ||  mobileMenuState ==="DREAM") 
                    &&
                   
                } */}
               
               
               <MobileMenuSlide 
                    bookMenuArr={bookMenuArr} 
                    dreamMenuArr={dreamMenuArr}
                    secondaryNavArr = {secondaryNavArr}
                    //showMobileMenuFunc = {backMobileMenu}
                    showMobileMenu = {mobileMenuState}
                />
               
            </div> 
            <BookSubMenuMobile 
                bookSubMenuData={bookMenuArr} 
                backMainMenu={backMainMenu}
                showSubMenu = {mobileMenuState}
                backNavFunc = {backMobileMenu}
                $mainMenuLinkTxt = {MainMenuLinkText}
                $customeProfileDetails = {customeProfileDetails}
                />
            <DreamSubMenuMobile 
                dreamSubMenuData={dreamMenuArr} 
                backMainMenu={backMainMenu}
                showSubMenu = {mobileMenuState}
                backNavFunc = {backMobileMenu}
                $mainMenuLinkTxt = {MainMenuLinkText}
            />
            <NotificationSlide {...props} backNavFunc={backMobileMenu} 
                showSubMenu = {mobileMenuState}
                $mainMenuLinkTxt = {MainMenuLinkText}
            />    
         </>   
        )
   
}

const mapStateToProps =(state) =>{
    return{ 
        mobileMenuState:state.CommonReducer.menuState,
        headerNav:state.CommonReducer.headerNavigation,
        MainMenuLinkText:state.CommonReducer.mainMenuLinkText,
        customeProfileDetails:state.CommonReducer.customerProfile
    }
    
}

const mapDispatchToProps = (dispatch) =>bindActionCreators({
    setMobileMenuStateFunc:setMobileMenuState,
    setMobileOverlayDisplayFunc:setMobileOverlayDisplay
  }, dispatch);


export default connect(mapStateToProps,mapDispatchToProps)(MobileSubMenu);
